import {actionMap} from '../reducer/index'
import * as types from './types'

export default (params) => dispatch => {
    return dispatch({
        type: types.HANDLE_ERROR,
        error: params
    })
}

export const handler_HANDLE_ERROR = (reduxState, action) => {
    return {
        ...reduxState,
        message: {
            status: action.error.status,
            text: action.error.message,
            title: action.error.title
        }
    }
}

actionMap[types.HANDLE_ERROR] = handler_HANDLE_ERROR


// WEBPACK FOOTER //
// ./src/shared/errorHandler/actions/handleError.js